import { FilterChoice } from '../common/components/SearchHeader/types/FilterChoice';
import { useRouter } from '../common/hooks/useRouter';
import { useHostName } from '../common/services/hostName';

export const useCanonicalPath = () => {
  const hostname = useHostName();
  const router = useRouter();
  const path = router?.asPath.split('?')[0] ?? '';
  return `https://${hostname}${path}`;
};

/**
 * SEO improvement to modify canonical url from /Next7Days/, /Tomorrow/, etc, to /NextAvailable
 */
export const useCanonicalNextAvailablePath = (filters: FilterChoice) => {
  const hostname = useHostName();
  const router = useRouter();
  const path = router?.asPath.split('?')[0] ?? '';
  const pathWithoutFilter = path.split('/').slice(0, -1).join('/');

  return filters.onlineAppointments
    ? `https://${hostname}${pathWithoutFilter}/NextAvailable`
    : `https://${hostname}${path}`;
};
